var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.81055V17.8105C3.5 18.341 3.71071 18.8497 4.08579 19.2248C4.46086 19.5998 4.96957 19.8105 5.5 19.8105H19.5C20.0304 19.8105 20.5391 19.5998 20.9142 19.2248C21.2893 18.8497 21.5 18.341 21.5 17.8105V9.81055M3.5 9.81055V7.81055C3.5 7.28011 3.71071 6.77141 4.08579 6.39633C4.46086 6.02126 4.96957 5.81055 5.5 5.81055H19.5C20.0304 5.81055 20.5391 6.02126 20.9142 6.39633C21.2893 6.77141 21.5 7.28011 21.5 7.81055V9.81055M3.5 9.81055H21.5M7.5 13.8105H12.5",
    stroke: "#FF395D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/CreditCard.bab7945801035778a78d0e50b404259a.svg";
export { ForwardRef as ReactComponent };